<div class="welcome-message">
	<div class="ico bubble-message-hi"></div>
	<p [innerHTML]="showCustomMessageHtml ? (customMessageHtml()! | safe: 'html') : (welcomeMessage | translate)"></p>
</div>
